module.exports = __webpack_public_path__ + "static/media/ladybug.9e578726.svg";